class PrintConsentFormService {
    border = '1px solid #0000001f';

    fontText = {
        fontSize: '14px',
        fontWeight: '500',
        lineHeight: '1.5'
    };

    groupBox = {
    border: '1px solid #0000001f',
    minHeight: '26.5mm'
    };

    paddingX = {
    px: '2.4mm'
    };

    spaceRow = {
    mt: '1.0mm'
    };

    spaceRow20px = {
    mt: '4.8mm'
    };

    spaceCol = {
    mr: '12.8mm'
    };

    // TODO: Manage in DB
    private readonly excludedSurgeries = [
        '弾性ストッキング',
        'キャッシュバック',
        '骨切り時の3D骨モデル作成 - 1回',
        'お誕生月特典'
    ];
    canDisplaySurgery = (surgeryName: string): boolean => {
        return !this.excludedSurgeries.some(excluded => 
            surgeryName.includes(excluded)
        );
    };

    // TODO: Manage in DB
    private readonly excludedSurgeriesInscription = [
        '脂肪採取作成料 - ',
        'ナノファット採取作成料',
    ];
    canDisplaySurgeryInscription = (surgeryName: string): boolean => {
        return !this.excludedSurgeriesInscription.some(excluded => 
            surgeryName.includes(excluded)
        );
    };
}

const printConsentFormService = new PrintConsentFormService();

export default printConsentFormService;